
  import { css } from 'lit';
  export const styles = css`[part="base focused"] ::slotted(div)::after{border:none;box-shadow:0 0 0 .25rem var(--button-focus-border-color)}`;
  